'use client';
import { FunctionComponent, useEffect, useRef } from 'react';
import { useAnalytics } from '../../../hooks/Analytics/useAnalytics';

export const EmbeddedAnalytics: FunctionComponent = () => {
    const hasEmittedAnalytics = useRef(false);
    const Analytics = useAnalytics();

    useEffect(() => {
        if (hasEmittedAnalytics.current === true) {
            return;
        }
        try {
            Analytics.record.event('Embedded Page Load', {
                embedURL: window.location.toString(),
                embeddedOn: document.referrer,
            });
            hasEmittedAnalytics.current = true;
        } catch (error) {}
    }, [Analytics]);

    return null;
};
